var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.778,
    height: 20,
    viewBox: "0 0 17.778 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "delete_FILL0_wght400_GRAD0_opsz48",
    d: "M10.806,26a1.66,1.66,0,0,1-1.667-1.667V8.5H8V6.833h5.222V6h7.333v.833h5.222V8.5H24.639V24.333A1.709,1.709,0,0,1,22.972,26ZM22.972,8.5H10.806V24.333H22.972ZM13.75,21.944h1.667V10.861H13.75Zm4.611,0h1.667V10.861H18.361ZM10.806,8.5v0Z",
    transform: "translate(-8 -6)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/trashCan.4159f6def3da68bf57a6290158afb1e0.svg";
export { ForwardRef as ReactComponent };